import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';

import { PATHS } from '@constants/paths';
import PathContext from '@contexts/ContextPath';
import { List, ListItem, ListItemIcon, ListItemText, Popover, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useCurrentUser } from '@shared/hooks';
import { getLabel } from '@shared/utils';
import map from 'lodash/map';
import { Link, useLocation } from 'react-router-dom';
import MenuIcon from './MenuIcon';

import './Menu.scss';

const useStyles = makeStyles(() => ({
  popover: {
    pointerEvents: 'none',
  },
  paper: {
    padding: '8px',
  },
  title_menu: {
    whiteSpace: 'normal',
  },
  web_menu: {
    top: '100px',
  },
}));

const isActivePath = (path) => {
  let [, pathname] = location.href.split('#');
  pathname = pathname || location.pathname;
  if (path === PATHS.HOME && pathname !== path) {
    return pathname === '/';
  }
  return pathname === path;
};

const menuItemKey = (path, name) => `${path}-${name}`;

const activeBarMenuItem = (displayName, path, name, setPathWindows) => {
  return (
    <PopopMenu
      displayName={displayName}
      path={path}
      name={name}
      active
      key={menuItemKey(path, name)}
      setPathWindows={setPathWindows}
    />
  );
};

const BarMenuItem = (displayName, path, name, setPathWindows) => {
  return (
    <PopopMenu
      displayName={displayName}
      path={path}
      name={name}
      key={menuItemKey(path, name)}
      setPathWindows={setPathWindows}
    />
  );
};

const MainListItems = ({ icons = false, handleClose, isWeb = true }) => {
  const location = useLocation();
  const { pathname: currentPath } = location;

  const classes = useStyles();
  const { path } = useContext(PathContext);
  const [pathWindows, setPathWindows] = useState(path);
  useEffect(() => {}, [pathWindows]);
  const user = useCurrentUser();
  const { permissions } = user;

  if (icons) {
    return (
      <List className="desktop-menu-list">
        <ListItem onClick={handleClose} component={Link} to={'/'} key={'-1'}>
          <ListItemIcon className={isActivePath(PATHS.HOME) ? 'desktop-menu-active' : ''}>
            <MenuIcon menuItem="home" />
          </ListItemIcon>
          <ListItemText
            primary={getLabel('start')}
            className={isActivePath(PATHS.HOME) ? 'desktop-menu-text-active' : ''}
          />
        </ListItem>
        {map(permissions, ({ display_name: displayName, name, path, main_menu: mainMenu }) => {
          return (
            mainMenu && (
              <ListItem onClick={handleClose} component={Link} to={path} key={menuItemKey(path, name)}>
                <ListItemIcon className={path === currentPath ? 'desktop-menu-active' : ''}>
                  <MenuIcon menuItem={name} />
                </ListItemIcon>
                <ListItemText
                  primary={displayName}
                  className={`${path === currentPath ? 'desktop-menu-text-active' : ''} ${classes.title_menu}`}
                />
              </ListItem>
            )
          );
        })}
      </List>
    );
  }

  return (
    <List className="list-popup-menu">
      {isActivePath(PATHS.HOME) && isWeb
        ? activeBarMenuItem(getLabel('start'), PATHS.HOME, 'home', setPathWindows)
        : BarMenuItem(getLabel('start'), PATHS.HOME, 'home', setPathWindows)}
      {map(permissions, ({ display_name: displayName, path, name, main_menu: mainMenu }) => {
        return (
          mainMenu &&
          (isActivePath(path) && isWeb
            ? activeBarMenuItem(displayName, path, name, setPathWindows)
            : BarMenuItem(displayName, path, name, setPathWindows))
        );
      })}
    </List>
  );
};

MainListItems.propTypes = {
  icons: PropTypes.bool,
  isWeb: PropTypes.bool,
  handleClose: PropTypes.func,
};

export default MainListItems;

const PopopMenu = ({ displayName, path, name, active, setPathWindows }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleChangePath = () => {
    setPathWindows(path);
  };

  const open = Boolean(anchorEl);

  return (
    <div>
      <ListItem
        onClick={handleChangePath}
        component={Link}
        to={path}
        className="content-menu-item"
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        onFocus={handlePopoverOpen}
        onBlur={handlePopoverClose}>
        {active ? (
          <div>
            <div className="active-icon-menu" />
            <div className="content-menu-item-active">
              <ListItemIcon>
                <MenuIcon menuItem={name} />
              </ListItemIcon>
            </div>
          </div>
        ) : (
          <div>
            <div className="content-menu-item-normal">
              <ListItemIcon>
                <MenuIcon menuItem={name} />
              </ListItemIcon>
            </div>
          </div>
        )}
      </ListItem>
      {open && (
        <Popover
          id="mouse-over-popover"
          className={classes.popover}
          classes={{
            paper: classes.paper,
          }}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          onClose={handlePopoverClose}
          disableRestoreFocus>
          <Typography className={classes.title_menu}>{displayName}</Typography>
        </Popover>
      )}
    </div>
  );
};

PopopMenu.propTypes = {
  displayName: PropTypes.string,
  path: PropTypes.string,
  name: PropTypes.string,
  active: PropTypes.bool,
  setPathWindows: PropTypes.func,
};
